import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CRUDPage from '../../components/admin/CRUDPage';
import { Folder } from 'lucide-react';

export default function CategoriesPage() {
  const fields = [
    { 
      key: 'name', 
      label: 'Category Name', 
      type: 'text', 
      required: true,
      placeholder: 'Enter category name'
    },
    { 
      key: 'description', 
      label: 'Description', 
      type: 'textarea', 
      required: false,
      placeholder: 'Enter category description (optional)'
    },
  ];

  return (
    <AdminLayout>
      <div className="p-8">
        <div className="bg-blue-50 border border-blue-200 px-4 py-3 rounded-lg mb-6">
          <p className="text-sm text-blue-800">
            <strong>ℹ️ Note:</strong> These categories are for <strong>Review Cards</strong> (Google/TripAdvisor review cards). 
            For <strong>Digital Cards</strong> (NFC business cards), use <strong>"Card Categories (Digital Cards)"</strong> instead.
          </p>
        </div>
        <CRUDPage
          title="Categories (Review Cards)"
          apiEndpoint="categories"
          dataKey="categories"
          fields={fields}
          icon={Folder}
        />
      </div>
    </AdminLayout>
  );
}
